import DeleteConfirmation from './DeleteConfirmation';
import GroupLocationsDialog from './GroupLocationsDialog';

const Dialogs = {
    DeleteConfirmation,
    GroupLocationsDialog,
};

export default Dialogs;
